import { ValueOf } from './value-of';

export const ACCOUNT_ROLE_CODES = {
  ADMIN: 'admin',
  CLIENT: 'client',
  UNAUTH: 'unauth',
} as const;

export type AccountRoleCode = ValueOf<typeof ACCOUNT_ROLE_CODES>;
